import Cookies from "js-cookie";
import { Navigate, Outlet } from "react-router-dom";
import TrackPageView from "../../TrackPages";


const RouteProtection = () =>{
    const instructor_id = Cookies.get("instructor_id");
    const token = Cookies.get("token");;

    // Check if the URL contains 'course_id' and store the path/url in localStorage
    const currentUrl = window.location.href;
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    
    if (currentUrl.includes("course_id")) {
        localStorage.setItem("urlPath", currentPath);
    }

    return(
        
        instructor_id && token?
                <>
                <TrackPageView />
                <Outlet/>
                </>
                :
                <Navigate to='/'/>

    )
};
export default RouteProtection;